import React from "react";
import { Link } from "react-router-dom";
import { SideBar } from "../sidebar";
import { getAllAuctionsByOrg, getSalesReport } from "../../../models/auctions";
import { getAllOrganization } from "../../../models/organization";
import DataTable from "react-data-table-component";
import i18n from "../../../i18n";
import { Spinner } from "react-bootstrap";
import { apiUrl } from "../../../constants/global";
import { getLoggedUser } from "../../../state/user";
import { HomeBanner } from "../../home/homeBanner";
const user = getLoggedUser();

export class SalesReport extends React.Component {
  constructor() {
    super();
    this.state = {
      input: {
        auction: "",
        downloadDoc: "pdf",
        organization: 1,
      },
      organizations: {},
      titles: {},
      bidders: {},
      total_amount: 0,
      phone_loader: false,
      open_popup: false,
      bidder_loading: false,
      customStyles: {
        headCells: {
          style: {
            fontWeight: "bold",
            backgroundColor: "#dadada",
            color: "#000000",
          },
        },
      },
      //actionsMemo : React.useMemo(() => <Export onExport={() => downloadCSV(data)} />, []),
      columns: [
        {
          name: i18n.t("bidder_id"),
          selector: "id",
          sortable: true,
          wrap: true,
        },
        {
          name: "Auction ID",
          selector: "auction_id",
          cell: (row) => <span>{row.auction_id}</span>,
        },
        // {
        //   name: "User ID",
        //   selector: "user_id",
        //   cell: (row) => <span>{row.user_id}</span>,
        // },
        // {
        //   name: "Name",
        //   selector: "name",
        //   cell: (row) => <span>{row.user.name}</span>,
        // },
        // {
        //   name: "Username",
        //   selector: "username",
        //   cell: (row) => <span>{row.user.username}</span>,
        // },
        {
          name: i18n.t("start_amount"),
          selector: "start_amount",
          sortable: true,
          cell: (row) => <span>{row.auction.start_amount}</span>,
        },
        {
          name: i18n.t("latest_bid_amount"),
          selector: "bid_amount",
          sortable: true,
        },
        {
          name: i18n.t("total_sales"),
          selector: "total_sales",
          sortable: true,
          cell: (row) => {
            if (row.bid_amount && row.auction.start_amount) {
              return Number(row.bid_amount) - Number(row.auction.start_amount);
            }
          },
        },
        {
          name: "Bid Date",
          selector: "created_at",
          sortable: true,
        },
      ],
    };

    this.handleChange = this.handleChange.bind(this);
    this.loadAuctionsByOrg = this.loadAuctionsByOrg.bind(this);
    this.loadData = this.loadData.bind(this);
  }

  componentDidMount() {
    this.loadAllOrganizations();
    //this.loadData();
  }

  handleChange(event) {
    let input = this.state.input;
    input[event.target.name] = event.target.value;
    this.setState({ input });
    if (event.target.name === "organization") {
      this.loadAuctionsByOrg(event.target.value);
    }
  }

  async loadAllOrganizations() {
    const response = await getAllOrganization();
    let organizations = response.data;
    this.setState({ organizations });
  }

  async loadAuctionsByOrg(organization) {
    if (organization) {
      this.setState({ phone_loader: true });
      const response = await getAllAuctionsByOrg(organization);
      if (response.data) {
        this.setState({ phone_loader: false });
        this.setState({ titles: response.data });
      }
    }
  }

  async loadData() {
    this.setState({ bidder_loading: true });
    const response = await getSalesReport(this.state.input);
    if (response.data) {
      this.setState({ bidder_loading: false });
      this.setState({ bidders: response.data });
      this.setState({ total_amount: response.meta });
    }
  }

  render() {
    let organizations = this.state.organizations;
    let titles = this.state.titles;
    let bidders = this.state.bidders;
    return (
      <React.Fragment>
        <HomeBanner />

        <section className="sptb mt-5">
          <div className="container">
            <div className="row">
              <div className="col-xl-3 col-lg-12 col-md-12">
                {!this.state.hideSidebar && <SideBar />}
              </div>
              <div
                className={
                  this.state.hideSidebar
                    ? "col-xl-12 col-lg-12 col-md-12"
                    : "col-xl-9 col-lg-12 col-md-12"
                }
              >
                <form
                  id="UpdateProfile"
                  className="card mb-0"
                  autoComplete="off"
                >
                  <div className="card-header">
                    <h3 className="card-title">
                      <span
                        style={{ fontSize: "1rem", marginRight: "0.5rem" }}
                        onClick={() => {
                          this.setState({
                            hideSidebar: !this.state.hideSidebar,
                          });
                        }}
                      >
                        {this.state.hideSidebar && (
                          <i className="icon-size-actual"></i>
                        )}
                        {!this.state.hideSidebar && (
                          <i className="icon-size-fullscreen"></i>
                        )}
                      </span>
                      {i18n.t("search")}
                    </h3>
                  </div>
                  <div className="card-body">
                    <div className="row">
                      {/* <div className="col-sm-12 col-md-5">
                        <div className="form-group">
                          <label className="form-label">
                            {i18n.t("organization")}
                          </label>
                          <select
                            className="form-control"
                            data-placeholder="Select Class"
                            name="organization"
                            value={this.state.input.organization}
                            onChange={this.handleChange}
                          >
                            <option value="">
                              --{i18n.t("organization")}--
                            </option>
                            {organizations.length > 0 &&
                              organizations.map((item) => {
                                return (
                                  <option value={item.id} key={item.id}>
                                    {item.organization_name}
                                  </option>
                                );
                              })}
                          </select>
                        </div>
                      </div> */}
                      <div className="col-sm-12 col-md-5">
                        <div className="form-group">
                          <label className="form-label">
                            {i18n.t("auction_name")}
                          </label>

                          <div className="input-group">
                            <select
                              className="form-control"
                              data-placeholder="Select Class"
                              name="auction"
                              value={this.state.input.auction}
                              onChange={this.handleChange}
                            >
                              <option value="">--{i18n.t("auction")}--</option>
                              {titles.length > 0 &&
                                titles.map((item) => {
                                  return (
                                    <option value={item.id} key={item.id}>
                                      {item.title}
                                    </option>
                                  );
                                })}
                            </select>

                            {this.state.phone_loader && (
                              <span
                                className="input-group-addon"
                                style={{
                                  position: "absolute",
                                  marginLeft: "54%",
                                  marginTop: "10px",
                                }}
                              >
                                <i className="fa fa-refresh fa-spin"></i>
                              </span>
                            )}
                          </div>
                        </div>
                      </div>
                      <div className="col-sm-12 col-md-2">
                        <div className="form-group">
                          <label className="form-label">&nbsp;</label>
                          <button
                            type="button"
                            className="form-control btn btn-primary"
                            onClick={this.loadData}
                            disabled={!this.state.input.organization}
                          >
                            {i18n.t("search")}
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </form>

                <hr />

                <div className="card mb-0">
                  <div className="card-header">
                    <h3 className="card-title" style={{ width: "65%" }}>
                      {i18n.t("result")}
                    </h3>

                    {bidders.length > 0 && (
                      <form
                        className="form-inline"
                        action=""
                        method="post"
                        target="_new"
                        style={{ width: "35%" }}
                        onSubmit={this.downloadDoc}
                      >
                        <div className="form-group mx-sm-3">
                          <select
                            className="form-control"
                            name="downloadType"
                            value={this.state.input.downloadType}
                            onChange={this.handleChange}
                          >
                            <option value={""}>Download As</option>
                            <option value={"pdf"}>PDF</option>
                            <option value={"excel"}>Excel</option>
                          </select>
                        </div>
                        {this.state.input.downloadType !== "" && (
                          <a
                            type="submit"
                            target="_new"
                            href={
                              apiUrl +
                              "sales_report/export?q=" +
                              this.state.input.downloadType +
                              "&org=" +
                              this.state.input.organization +
                              "&auction=" +
                              this.state.input.auction +
                              "&u=" +
                              user.role
                            }
                            className="btn btn-outline-danger"
                          >
                            {i18n.t("download")}
                          </a>
                        )}
                      </form>
                    )}
                  </div>
                  <div className="card-body">
                    <div className="table-responsive ">
                      {this.state.bidder_loading && (
                        <div className="text-center">
                          <Spinner animation="border" />
                        </div>
                      )}
                      {!this.state.bidder_loading && !bidders.length && (
                        <div className="alert alert-danger">
                          {i18n.t("no_result")}
                        </div>
                      )}
                      {!this.state.bidder_loading && bidders.length > 0 && (
                        <div className="table-wrapper">
                          <DataTable
                            title=""
                            columns={this.state.columns}
                            data={bidders}
                            customStyles={this.state.customStyles}
                            highlightOnHover
                            pagination
                            paginationPerPage={15}
                            paginationRowsPerPageOptions={[15, 25, 50, 100]}
                            paginationComponentOptions={{
                              rowsPerPageText: "Bidders per page:",
                              rangeSeparatorText: i18n.t("out"),
                            }}
                            //actions={this.state.actionsMemo}
                          />
                        </div>
                      )}
                      {/* {!this.state.bidder_loading && bidders.length > 0 && (
                        <div style={{ textAlign: "right", fontWeight: "bold" }}>
                          Total Amount : {i18n.t("omr")}{" "}
                          {this.state.total_amount}
                        </div>
                      )} */}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </React.Fragment>
    );
  }
}
